import React from 'react';

import './style.scss';
import { Strings } from '../../../shared/constants/Constants';

const QuestionResult = ({ answerTitle, answerDescription }) => {
  return (
    <>
      <div className='result-heading'>
        <h5>{answerTitle}</h5>
      </div>
      <p className='mt-1' style={{ color: '#666' }}>
        {answerTitle === Strings.thatsNotCorrect
          ? Strings.correctAnswerIs
          : `${Strings.description}:`}
      </p>
      <div className='correct-answer'>{answerDescription}</div>
    </>
  );
};

export default QuestionResult;
